<template>
    <div>
        <div class="uk-flex">
            <a v-if="editable" href class="uk-button uk-button-primary uk-margin-right" @click.prevent="toggle"><open-icon glyph="edit" /></a>
            <div>
                <div class="uk-text-muted uk-form-controls-text uk-margin-small-top" v-if="!value||!value.length">(No type assigned)</div>
                <div v-if="value.length" class="uk-form-controls-text uk-margin-small-top">
                    {{ category_names }}
                </div>
            </div>
        </div>

        <modal-dialog
            :id="`category-opicker-${id}`"
            :show.sync="editing"
            class="uk-modal-dialog-large lam-category-picker"
        >
            <template v-slot:title>
                {{ title }}
            </template>
            <template v-slot:subtitle>
                {{ subtitle }}
            </template>

            <category-picker-list
                :parent="root_parent"
                :selected-ids="value"
                :filtered="filtered"
                :nb-columns="6"
                :rows-per-column="10"
                :required-sections="requiredSections"
                @pick="toggle_category"
            />
        </modal-dialog>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import ModalDialog from "../dialogs/ModalDialog/ModalDialog"
import CategoryPickerList from "./CategoryPickerList"
import OpenIcon from "./OpenIcon"

export default {
    components: {
        ModalDialog,
        CategoryPickerList,
        OpenIcon
    },
    mounted () {
        this.$store.dispatch("FETCH_RECORDS", { entity: "category" })
    },
    computed: {
        ...mapGetters(["entity_records", "entity_record"]),
        raw_category_records () {
            return this.entity_records("category")
        },
        category_names () {
            return this.value.map(category_id => {
                const category = this.entity_record("category", category_id)
                return category ? category.name : ""
            }).filter(name => !!name).join(", ")
        },
        root_parent () {
            if(this.filtered !== "overhead") return null
            const overhead_category = this.raw_category_records.find(category => {
                return !!category.name.match(/^overhead\sprojects$/i)
            })
            return overhead_category
        }
    },
    methods: {
        toggle () {
            this.editing = !this.editing
        },
        toggle_category (checked, category_id) {
            this.$emit("change", checked, category_id)
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        value: {
            required: true
        },
        filtered: {
            type: String,
            default: "" // "overhead", "regular"
        },
        editable: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: "Project Types"
        },
        subtitle: {
            type: String,
            default: ""
        },
        requiredSections: {
            type: Array,
            default () {
                return ["General Types"]
            }
        }
    },
    data () {
        return {
            editing: false
        }
    }
}
</script>

<style lang="less">
.lam-category-picker {
    & > .uk-modal-dialog {
        width: 100%;
        max-width: none;
    }
}
</style>
